import { styled } from 'ui/styles'

export const BoxShadow = styled.div`
  box-shadow: 0px 45px 90px rgba(8, 16, 36, 0.15);
  border-radius: 24px;
  box-sizing: border-box;
`
